import vidFleetVideoRedux from 'Modules/.common/components/VidFleetVideo/redux/reducer';
import dtcRedux from 'Modules/.common/components/Dtc/redux/slice';
import sharedMediaRedux from 'Modules/.common/components/SharedMedia/redux/reducer';
import accountInformationRedux from 'Modules/.common/components/AccountInformation/redux/reducer';
import smartwitnessVideoRedux from 'Modules/.common/components/SmartWitnessVideo/redux/reducer';
import iconPickerRedux from 'Modules/.common/components/IconPicker/redux/reducer';
import SliderRangeVideoRedux from 'Modules/.common/components/SliderRangePanel/redux/reducer';
import troubleshootDeviceRedux from 'Modules/.common/components/TroubleshootDevice/redux/slice';
import cameraSetupRedux from 'Modules/.common/components/CameraSetup/redux/slice';
import warningsRedux from 'Modules/.common/components/Warnings/redux/slice';
import warningsDetailsRedux from 'Modules/.common/components/Warnings/.components/Details/redux/slice';
import warningsConfirmResolveRedux from 'Modules/.common/components/Warnings/.components/ConfirmResolve/redux/slice';
import warningsResolveRedux from 'Modules/.common/components/Warnings/.components/Resolve/redux/slice';
import warningsDeleteRedux from 'Modules/.common/components/Warnings/.components/Delete/redux/slice';
import videoAssignDriverRedux from 'Modules/.common/components/VideoAssignDriver/redux/slice';
import videoRedux from 'Modules/.common/components/Video/redux/slice';
import transactionsSummaryRedux from 'Modules/.common/components/TransactionsSummary/redux/slice';
import filterAvatarsRedux from 'Modules/.common/components/FilterAvatars/redux/slice';
import lightMetricsRedux from 'Modules/.common/components/LightMetricsVideo/redux/slice';
import mitacRedux from 'Modules/.common/components/MitacVideo/redux/slice';
import entityPickerRedux from 'Modules/.common/components/EntityPicker/redux/reducer';
import createEditTagSlice from 'Modules/account/views/tags/components/createEditTag/redux/slice';
import infoBubbleRedux from 'Modules/.common/components/InfoBubble/redux/slice';

export default {
	vidFleetVideoRedux,
	infoBubbleRedux,
	dtcRedux,
	sharedMediaRedux,
	accountInformationRedux,
	smartwitnessVideoRedux,
	iconPickerRedux,
	SliderRangeVideoRedux,
	troubleshootDeviceRedux,
	cameraSetupRedux,
	warningsRedux,
	warningsDetailsRedux,
	warningsConfirmResolveRedux,
	warningsResolveRedux,
	warningsDeleteRedux,
	videoAssignDriverRedux,
	videoRedux,
	transactionsSummaryRedux,
	filterAvatarsRedux,
	lightMetricsRedux,
	mitacRedux,
	entityPickerRedux,
	createEditTagSlice
};